import { Book } from "../types/Book";
import { API_URL } from "../utils";

export default async (query: string, internalId?: boolean): Promise<Book> => {
	const result: Book = await (await fetch(`${API_URL}/books/book?${internalId ? 'id' : 'eId'}=${query}`, {
		credentials: 'include'
	})).json();

	return result;
};
